/* global imagesLoaded, Isotope: false */

export default class IsotopeFilters {
    constructor(el) {
        if (!el) return;

        this.el = el;
		this.iso = null;

        this.init();
		this.events();
    }

    init() {
		if (!this.el.dataset.isotope) return;

		this.iso = new Isotope(this.el, JSON.parse(this.el.dataset.isotope));
    }

	events() {
		if (!this.iso) return;

		window.addEventListener('resize', () => {
			this.iso.layout();
		}, true);

		// Ensure layout runs after each image load
		imagesLoaded(this.el) .on('progress', () => {
			this.iso.layout();
		});

		document.querySelectorAll('.isotope-filters button').forEach(el => {

			el.addEventListener('click', ev => {
				const current = ev.currentTarget;
				const group = current.parentElement.parentElement;

				// Remove active from siblings
				group.querySelectorAll('.active').forEach(btn => btn.classList.remove('active'));

				// Add active to clicked button
				current.classList.add('active');

				this.iso.arrange({
					filter: current.dataset.filter,
				});

				this.iso.layout();
			}, false);
		});

		// Needed for electrahotels partners filtering.
		window.addEventListener('verity-guest.shown.bs.tab', () => {
			if (this.iso) this.iso.layout();
		});
	}
}

Array.from(document.querySelectorAll('[data-isotope]')).map(el => new IsotopeFilters(el));

// Needed for electrahotels partners filtering.
window.addEventListener('view.rendered', () => {
	Array.from(document.querySelectorAll('[data-isotope]')).map(el => new IsotopeFilters(el));
});
